

const bookingHistoryDefaultState = {
  hasError: false,
  isFetching: false,
  isReady: false,
  bookings: []
}

const addBookingHistoryState = (state) => {
  return {bookingHistory: state ? Object.assign({}, bookingHistoryDefaultState, state) : bookingHistoryDefaultState}
}

const loginDefaultState = Object.assign({}, addBookingHistoryState())

const loginReducer = (state = loginDefaultState, action) => {
  // We need this now for the old bookings
  // if (state && state.hasOwnProperty('bookings')) {
  //   delete state.bookings
  // }

  switch (action.type) {
    case 'LOGOUT':
      return Object.assign({}, addBookingHistoryState(state.bookingHistory), loginDefaultState, {
        validUser: state.validUser
      })

    case 'LOGIN':
      return Object.assign({}, addBookingHistoryState(state.bookingHistory), loginDefaultState, action.data)

    case 'LOGIN_FAILED':
      return Object.assign({}, addBookingHistoryState(), state, {
        failedLogin: action.data
      })

    case 'VALID_USER':
      return Object.assign({}, addBookingHistoryState(), state, {
        validUser: action.data
      })

    case 'INVALID_USER':
      return Object.assign({}, addBookingHistoryState(), state, {
        validUser: false
      })

    case 'SENT_MAGICLINK':
      return Object.assign({}, addBookingHistoryState(), state, {
        sentMagicLink: action.data
      })

    case 'BOOKING_HISTORY_FETCH':
      return Object.assign({}, state, addBookingHistoryState({
        isFetching: true
      }))

    case 'BOOKING_HISTORY_ERROR':
      return Object.assign({}, state, addBookingHistoryState({
        hasError: true,
        errorMessage: action.data
      }))

    case 'BOOKING_HISTORY_READY':
      // Changed the a.date b.date and booking.date to be old style start_at
      if (!action.data) return state
      const bookings = action.data
          .sort((a, b) => new Date(a.start_at).getTime() - new Date(b.start_at).getTime())
          .filter((booking) => new Date(booking.start_at) > new Date())
          // .reverse()

      return Object.assign({}, state, addBookingHistoryState({
        isReady: true,
        bookings: bookings
      }))

    default:
      return Object.assign({}, loginDefaultState, addBookingHistoryState(bookingHistoryDefaultState), state)
  }
}

module.exports = loginReducer
